"use strict";
(function (global) {

  var TEMPLATE = '/components/referenceRequisite.compile.html';

/** 
* Реквизит типа «Справочник».
* 
* @since 5.0.0.4000
* @class WebAccess.components.forms.requisites.ReferenceSelect
* @param {string|WebAccess.components.forms.requisites.ReferenceSelect.settings} id Идентификатор элемента. Является обязательным параметром
* @param {string} referenceCode Код справочника
* @param {string} [opt_toolTip] Всплывающая подсказка
* @param {string} [opt_searchReqName] Название отображаемого реквизита
* @param {string} [opt_filter] Выражение фильтрации элементов выбранного справочника

* @property {string} id Идентификатор элемента
* @property {string} referenceCode Код справочника
* @property {string} toolTip Всплывающая подсказка
* @property {string} searchReqName Название отображаемого реквизита
* @property {string} filter Выражение фильтрации элементов выбранного справочника
* @property {string} html HTML-разметка элемента
*
* @fires render вызывается после того, как HTML-разметка собрана и готова к использованию.
* @throws ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED - заданы не все обязательные параметры.
* @example
* var field = new WebAccess.components.forms.requisites.ReferenceSelect("employe_select", "РАБ").render();
*     WebAccess.current.sideBar.tabs.FldTree.setHtml(field);
*/

/** 
* @typedef {object} WebAccess.components.forms.requisites.ReferenceSelect.settings
* @property {string} id Идентификатор формы справочника
* @property {string} referenceCode Код справочника
* @property {string} toolTip Всплывающая подсказка
* @property {string} searchReqName Наименование отображаемого реквизита
* @property {string} filter Выражение фильрации элементов выбранного справочника
* @property {string} html HTML-разметка элемента
*/
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


  

  var ReferenceSelect = BaseObject.extend({
    init: function (id, referenceCode, opt_toolTip, opt_searchReqName, opt_filter) {
      this._super(id);
      if (!id) return;

      if ($.isPlainObject(id)) {
        $.extend(this, id);
      } else {  
        if (!referenceCode) WA.raise("ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED");        
        this.id = id;
        this.referenceCode = !!referenceCode ? referenceCode : "ПОД";                        
        this.toolTip = !!opt_toolTip ? opt_toolTip : "";
        this.searchReqName = !!opt_searchReqName ? opt_searchReqName : "Наименование";
        this.filter = !!opt_filter ? opt_filter : "";
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    className: "ReferenceSelect",    
    id: "",
    referenceCode: "",    
    toolTip: "",
    searchReqName: "Наименование",
    filter: "",
    html: "",
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    
    /**
     * Генерировать HTML-разметку
     * @function WebAccess.components.forms.requisites.ReferenceSelect#render
     * @return {string} Сгенерированная HTML-разметка
     */
    render: function() {      
      var result = "";
      var requestMap = { 
        "ID": this.id.toLowerCase(),
        "ReferenceCode": this.referenceCode,       
        "ToolTip": this.toolTip, 
        "SearchReqName": this.searchReqName, 
        "Filter": this.filter
      };

      CallServiceSync("/Requisite.asmx/ReferenceSelect", requestMap, function (response) {
        if (response.Success) {
          result = response.Result.html;
        }
        else ShowMessage(response.Result);
      });

      this.fire("render");
      this.html = result;
      return result;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    
    /**
     * Асинхронно генерирует HTML-разметку 
     * @function WebAccess.components.forms.requisites.ReferenceSelect#renderAsync
     * @return {string} Сгенерированная HTML-разметка.
     * @since 5.2.0.1200
     */
    renderAsync: function (opt_data) {
     //TODO: Этот метод использует hogan шаблон, а для его работы необходимо много данных,
     //в том числе частично нужны данные с серверной стороны. В будущем необходимо эти
     //данные научится формировать либо получать. Сейчас пока этот метод будет работать
     //только если предоствить все данные явно. В будущем метод render(тот что выше) нужно 
     //будет переделать на него, но с флагами синхронного вызова.
      var me = this;
      var data = opt_data || me.getData();
      var result = $.Deferred();
      if (!opt_data) WA.raise('NOT_IMPLEMENTED_EXCEPTION')

      WA.templates.render(TEMPLATE, opt_data).done(function (html) {
        me.html = html;
        result.resolve(me.html);
        me.fire("render");
      });

      return result;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });
  
  global.ReferenceSelect = ReferenceSelect;
})(window.WebAccess.components.forms.requisites);